import { LocaleData, LocaleConfig } from '../types';

export const config: LocaleConfig = {
    id: 'sl',
    fullName: 'Slovenian',
    nativeName: 'Slovenščina',
    direction: 'ltr'
};

const translations: LocaleData = {
    title: "ArgVoid",
    landing_title: "Prihaja nekaj neverjetnega",
    landing_subtitle: "ArgVoid je studio za razvoj aplikacij in iger. Ostanite z nami, kmalu prihajajo novosti!",
    select_language: "Izberite Jezik",
    search_placeholder: "Iskanje jezikov ...",
    terms_title: "Pogoji storitve",
    policy_title: "Politika zasebnosti",
    cookies_title: "Politika piškotkov",
    terms_content: `
        <strong>1. Sprejemanje pogojev </strong><br>
        Z dostopom do ArgVoid so ti pogoji storitve sprejeti. Če se s temi pogoji ne strinjate, storitve ne smete uporabljati.<br><br>

        <strong>2. Uporaba platforme</strong><br>
        ArgVoid in njegove aplikacije so na voljo "takšne kot so" v informativne in ustvarjalne namene. Storitev se sme uporabljati samo za zakonite namene.<br><br>

        <strong>3. Prepovedano ravnanje</strong><br>
        Izkoriščanje ranljivosti spletnega mesta, pošiljanje neželene pošte ali poskus nepooblaščenega dostopa do infrastrukture je strogo prepovedano.<br><br>

        <strong>4. Zavrnitev odgovornosti</strong><br>
        Platforma in storitve se lahko kadar koli spremenijo brez predhodnega obvestila. Glede časa delovanja ali razpoložljivosti storitve ni nobenega jamstva.
    `,
    policy_content: `
        <strong>1. Zbirka informacij </strong><br>
        Platforma trenutno ne zahteva preverjanja pristnosti uporabnika ali ustvarjanja računa. Od obiskovalcev se aktivno ne zbira nobenih osebnih podatkov (kot so imena ali e-poštni naslovi).<br><br>

        <strong>2. Podatki o uporabi </strong><br>
        Za razumevanje prometa na spletnem mestu in izboljšanje aplikacij se lahko zbira osnovna, anonimizirana analitika. Ti podatki niso povezani z identitetami posameznih uporabnikov.<br><br>

        <strong>3. Storitve tretjih oseb </strong><br>
        Za storitve gostovanja in analitike se lahko uporabijo ponudniki tretjih oseb. Prakse zasebnosti teh zadevnih ponudnikov urejajo anonimne podatke, ki se obdelujejo v njihovi infrastrukturi. <br><br>

        <strong>4. Varnost podatkov</strong><br>
        Za zaščito platforme se izvajajo razumni varnostni ukrepi. Vendar pa noben način prenosa prek interneta ni popolnoma varen.<br><br>
    `,
    cookies_content: `
        <strong>1. Kaj so piškotki in lokalna shramba? </strong><br>
        Piškotki in lokalni pomnilnik brskalnika so majhne podatkovne datoteke, shranjene v napravi, da si zapomnijo konfiguracijske nastavitve med obiski.<br><br>

        <strong>2. Namen uporabe </strong><br>
        Browser LocalStorage se uporablja izključno za shranjevanje konfiguracijskih nastavitev, kot je: <br>
        - Jezikovne nastavitve <br>
        - Konfiguracija uporabniškega vmesnika (npr. nastavitve postavitve ali teme) <br>
        - Začasni predpomnilnik aplikacij <br><br>

        <strong>3. Brez sledenja</strong><br>
        Piškotki in lokalna shramba se ne uporabljajo za namene oglaševanja ali sledenja tretjih oseb. Vsi shranjeni podatki so izključno za osnovno funkcionalnost platforme.<br><br>

        <strong>4. Control</strong><br>
        Podatke brskalnika lahko kadar koli izbrišete prek nastavitev brskalnika, kar bo ponastavilo vse lokalne konfiguracije.
    `,
    cookie_consent_text: "Osnovne piškotke uporabljamo za zagotavljanje pravilnega delovanja spletnega mesta, na primer za ohranjanje aktivne seje, shranjevanje vaših jezikovnih nastavitev in druge konfiguracije po meri.",
    read_policy: "Preberite Politiko piškotkov",
    support_title: "Obrnite se na podporo",
    support_subject_label: "Predmet",
    support_message_label: "Sporočilo",
    support_submit_button: "Pošlji sporočilo",
    support_hint: "Opomba: S tem se odpre vaša privzeta e-poštna aplikacija za pošiljanje sporočila.",
    support_success_msg: "Odpiranje e-poštne aplikacije ...",
    support_error_msg: "Sporočila ni bilo mogoče poslati. Poskusite znova pozneje.",
    explorer_title: "Raziskovalec",
    history_title: "Zgodovina",
    animation_title: "Animacija",
    config_title: "Konfiguracija",
    tool_mouse: "Izberi (Ctrl+M)",
    tool_brush: "Čopič (Ctrl+B)",
    tool_brush_mode: "Preklopni način (polno/jasno)",
    tool_eraser: "Radirka (Ctrl+E)",
    tool_brush_size: "Prilagodite velikost krtače",
    tool_bucket: "Izpolni (Ctrl+F)",
    tool_eyedropper: "Kapalka",
    tool_grid: "Mreža (Ctrl+Shift+B)",
    tool_rotate: "Zasukaj (Ctrl+Shift+R)",
    tool_flip_h: "Obrni H (Ctrl+Shift+H)",
    tool_flip_v: "Obrni V (Ctrl+Shift+V)",
    tool_transpose: "Transponiranje (Ctrl+Shift+T)",
    label_width: "širina",
    label_height: "Višina",
    label_frames: "Število okvirjev",
    label_animation: "Slog animacije",
    label_background_color: "Barva ozadja",
    label_interval: "Interval",
    tool_anim_config: "Konfiguracija animacije",
    label_new_width: "Nova širina",
    label_new_height: "Nova višina",
    label_apply: "Prijavite se",
    label_colors: "Barve",
    label_size: "Velikost",
    label_tolerance: "Strpnost",
    val_horizontal: "Vodoravno",
    val_vertical: "Navpično",
    val_sequence: "Zaporedje",
    val_bounce: "Odboj",
    val_random: "Naključno",
    val_solid: "Trdna",
    val_clear: "jasno",
    action_add_sheet: "Nov list",
    action_import: "Uvozi",
    action_export: "Izvozi",
    action_sort_projects: "Razvrsti",
    sort_date_old: "Najprej najstarejši",
    sort_date_new: "Najprej najnovejše",
    sort_name_az: "Ime (A-Z)",
    sort_name_za: "Ime (Z-A)",
    action_new_sprite: "Nov Sprite",
    action_new_project: "Nov projekt",
    modal_save_all_title: "Shrani vse spremembe",
    modal_save_all_desc: "Izberite sredstva, ki jih želite shraniti:",
    modal_save_selected: "Shrani izbrano",
    action_saved: "Shranjeno",
    modal_create_sprite_title: "Ustvari nov sprite",
    modal_create_project_title: "Ustvari nov projekt",
    modal_add_sheet_title: "Dodaj nov list",
    modal_rename_sheet_title: "Preimenuj list",
    modal_rename_sprite_title: "Preimenuj Sprite",
    modal_delete_sprite_title: "Izbriši Sprite",
    modal_delete_project_title: "Izbriši projekt",
    modal_delete_sheet_title: "Izbriši list",
    placeholder_sprite_name: "Ime",
    placeholder_project_name: "Ime",
    placeholder_sheet_name: "Ime",
    placeholder_new_name: "Novo ime",
    action_create: "Ustvari",
    action_add: "Dodaj",
    action_rename: "Preimenuj",
    action_duplicate: "Dvojnik",
    action_delete: "Izbriši",
    action_cancel: "Prekliči",
    confirm_delete_sprite: "Ali ste prepričani, da želite izbrisati ta duh?",
    confirm_delete_project: "Ali ste prepričani, da želite izbrisati ta projekt? Vsi spriti bodo odstranjeni.",
    confirm_delete_sheet: "Ali ste prepričani, da želite izbrisati ta list?",
    err_select_sprite: "Najprej izberite sprite.",
    err_select_project: "Najprej izberite projekt.",
    err_name_empty: "Ime ne sme biti prazno.",
    err_sprite_exists: "Sprite s tem imenom že obstaja.",
    err_project_exists: "Projekt s tem imenom že obstaja.",
    err_no_content: "Ni vsebine za shranjevanje.",
    err_no_changes: "Ni sprememb za shranjevanje.",
    err_delete_last_sheet: "Zadnjega lista ni mogoče izbrisati.",
    err_extract_frames: "Ni bilo mogoče izvleči nobenega okvirja.",
    err_indexeddb: "Lokalno shranjevanje ni uspelo. Vaš brskalnik morda ne podpira IndexedDB.",
    msg_upload_success: "Nalaganje uspešno: {0}",
    msg_upload_failed: "Nalaganje ni uspelo: {0}",
    msg_save_success: "Shranjevanje uspešno.",
    msg_saving: "Shranjevanje ...",
    msg_multi_save_result: "Shranjenih {0} sredstev. {1} napak.",
    menu_title: "meni",
    menu_save: "Shrani",
    menu_save_all: "Shrani vse",
    menu_support: "Obrnite se na podporo",
    label_local_storage: "Lokalna shramba",
    label_sign_in: "Prijavite se",
    modal_export_title: "Izvozi Sprite",
    label_filename: "Ime datoteke",
    label_format: "Oblika",
    action_export_confirm: "Izvozi",
};

export default translations;
